<template>
  <div class="set-risk-dialog">
    <base-dialog :visible.sync="setRiskVisible" show-close width="800px">
      <template v-slot:header>
        标记为项目风险
      </template>
      <el-form :model="risk" class="risk-form">
        <el-form-item label="风险等级">
          <el-select v-model="risk.riskLevel" placeholder="请选择风险等级">
            <el-option label="低" :value="1"></el-option>
            <el-option label="中" :value="2"></el-option>
            <el-option label="高" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应对方案">
          <!--          窗口打开时新建富文本框 进行初始化操作-->
          <rich-input v-if="setRiskVisible" v-model="risk.copingPlan"></rich-input>
        </el-form-item>
        <el-form-item label="任务附件">
          <upload-file
            ref="uploadFile"
            :oneFlag="false"
            @updateFiles="setAttachmentIds"
          ></upload-file>
        </el-form-item>
        <el-form-item label="任务备注">
          <rich-input v-if="setRiskVisible" v-model="risk.description"></rich-input>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button type="primary" @click="$emit('submit', risk)">保存</base-button>
        <base-button @click="setRiskVisible = false">取消</base-button>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import UploadFile from "@/components/Sheet/SheetForm/FormItem/UploadFile/index.vue"
import RichInput from "@/components/FormControl/RichInput.vue"
import BaseDialog from "@/components/BaseComponents/Dialog.vue"
import BaseButton from "@/components/UIComponents/Button.vue"

export default {
  name: "set-risk-dialog",
  components: {
    UploadFile,
    RichInput,
    BaseButton,
    BaseDialog
  },
  props: {},
  data() {
    return {
      setRiskVisible: false,
      risk: {
        copingPlan: "",
        riskSet: false,
        riskLevel: null,
        description: "",
        attachmentIds: []
      }
    }
  },
  methods: {
    init(taskInfo) {
      this.risk.riskLevel = taskInfo.riskLevel === 0 ? null : taskInfo.riskLevel
      this.risk.copingPlan = taskInfo.copingPlan
      this.risk.attachmentIds = taskInfo.attachmentIds
      this.risk.description = taskInfo.description
      this.risk.riskSet = true
      this.$nextTick(() => {
        this.$refs.uploadFile.init(taskInfo.attachments)
      })
      this.setRiskVisible = true
    },
    setAttachmentIds(val) {
      this.risk.attachmentIds = val.map(item => item.id)
    },
    closed() {
      this.setRiskVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.risk-form {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .el-form-item {
    width: 50%;
    display: flex;
    .el-select,
    .tox-tinymce,
    .upload-file {
      width: 298px !important;
    }
    .tox-tinymce,
    .upload-file {
      height: 200px;
    }
  }
}
</style>
